import React from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { useModalStyles } from "../Util/CSS/ModalStyles";
import ReactJson from 'react-json-view'

const ModalComp = ({
  open,
  handleClose,
  whichModal,
  children,
  minHeight,
  top,
  topMobile,
  height,
  width,
}) => {
  const classes = useModalStyles(top, topMobile, height, width, minHeight);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflowY:"scroll"
      }}
    >
      <Modal
        aria-labelledby="Modal"
        aria-describedby="This is a Modal"
        className={classes.modal}
        open={open}
        onClose={() => handleClose(whichModal)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            {whichModal === "pos" ? <ReactJson src={children} /> : children}
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default ModalComp;
